module.exports = __webpack_public_path__ + "img/Logo(1).b1030d93.svg";